module.exports = __webpack_public_path__ + "img/bg-top-right.9e9d59ad.svg";